let config;
const isDev = process.env.VUE_APP_API_MODE === "development";
export const apiConfig = process.env.VUE_APP_API_URL.replace('{MODE}', isDev ? 'dev' : 'uat');

if (process.env.VUE_APP_CONFIG === 'prod') {
  config = {
    graphapi: 'https://graph.microsoft.com/v1.0/sites/',
    graphuserapi: 'https://graph.microsoft.com/v1.0/me/',
    token: {
      tenant_id: '4476eab3-3533-4a64-9a5a-7f6fe80589e3', // 4476eab3-3533-4a64-9a5a-7f6fe80589e3
      grant_type: 'authorization_code',
      client_id: '2c5f124f-cbb0-47b8-bfc2-3599dd514551', // 13891419-b18c-4a16-be46-c87c0b6635fb
      client_secret: 'ElBU24h~p204JQ.~D90dg.W68kex0NYy~E', // 'c4f7KjqCuohAPoX/Q+21sKsAtYbXUBmDqKitz0kVOrU=',//+]1_xbWkWU]uzM8k0qoIHSKAM2DgIS5+
      scope: 'offline_access https://graph.microsoft.com/.default',
      bus_id: "SOuB72nfuqYMdACAk71RHGeUFmSb"
    },
    sharepoint: {
      testsite_id:
        'starluxairlines.sharepoint.com,3c8ef63f-5cd0-4232-9cce-fa4e49067cab,7f50c4b7-a460-4468-982e-de538c0a9813',
      eipsite_id:
        'starluxairlines.sharepoint.com,afcf72c6-d604-42b6-8da4-831bfaab02df,707530a2-f175-483e-96e9-aefe2fec6c69',
      pilotportalsite_id:
        'starluxairlines.sharepoint.com,3c52a925-47d4-4749-a59a-7299bdedcc3b,0a36af78-8b15-4f22-b492-a392afe1be2f'
    },
    pilotportal: {
      news_list: 'NewsClip',
      notice_list: 'Notice',
      admin_list: 'Admin List',
      bulletin_id: 'b!JalSPNRHSUelmnKZve3MO3ivNgoViyJPtJKjkq_hvi_D4rgOBHqWToK5G9LH2PsT',
      manual_id: 'b!JalSPNRHSUelmnKZve3MO3ivNgoViyJPtJKjkq_hvi8Jt5BiBrq2R45tJEmGz_sA',
      'personnel info_id': 'b!JalSPNRHSUelmnKZve3MO3ivNgoViyJPtJKjkq_hvi9bkeNT9rsyQpoqMPQf-j9g',
      'training material_id': 'b!JalSPNRHSUelmnKZve3MO3ivNgoViyJPtJKjkq_hvi9Htxn8LUeRTI8PEYneCiR8',
      'Check Pilots (CP)_id': 'b!JalSPNRHSUelmnKZve3MO3ivNgoViyJPtJKjkq_hvi-kl6JUaqxHQ60nq2ncdkJm',
      'Instructor Pilots (IP)_id': 'b!JalSPNRHSUelmnKZve3MO3ivNgoViyJPtJKjkq_hvi8uNo_yLDF2SLfqCZartaJk',
      'supervisory pilots_id': 'b!JalSPNRHSUelmnKZve3MO3ivNgoViyJPtJKjkq_hvi_eztV-wzTYRbjg0uDFH3JF',
      pss_id: 'b!JalSPNRHSUelmnKZve3MO3ivNgoViyJPtJKjkq_hvi-bzGbsmG38TJmY3N8ke5fr',
      hotel_id: 'b!JalSPNRHSUelmnKZve3MO3ivNgoViyJPtJKjkq_hvi9lCvAFO1eiSpTRiYseKw7k',
      'CASE STUDY_id': 'b!JalSPNRHSUelmnKZve3MO3ivNgoViyJPtJKjkq_hvi_dGo3tH-29RpIbmHeF1hmf',
      airportInfo_id: 'b!JalSPNRHSUelmnKZve3MO3ivNgoViyJPtJKjkq_hvi-hRSwWJqXHQYPUmOyTcrzR',
      crewconnect_list: 'Crew Connect',
      category: ['General', 'A321', 'A330', 'A350'],
      pilot: ['Check Pilots (CP)', 'Instructor Pilots (IP)']
    },
    post_logout_redirect_uri: 'https://pilotstarspace.starlux-airlines.com/#/login'
  }
} else {
  config = {
    graphapi: 'https://graph.microsoft.com/v1.0/sites/',
    graphuserapi: 'https://graph.microsoft.com/v1.0/me/',
    token: {
      tenant_id: '4476eab3-3533-4a64-9a5a-7f6fe80589e3', // 4476eab3-3533-4a64-9a5a-7f6fe80589e3
      grant_type: 'authorization_code',
      client_id: '9fcf9cc4-693f-4f5a-8fae-357e2d615767', // '7837d0f1-fb44-4c86-8fc9-954255fa5a65',
      client_secret: 'qLX2Y3BT~Tmn.a34pTS_5Jepx49U7.8v2F', // 'oyMgd_f34T8uIxb.pHfhN2TJtlhEsr/=',
      scope: 'offline_access https://graph.microsoft.com/.default',
      bus_id: "as2dfasdfasdf12weIPFJSrw123e"
    },
    sharepoint: {
      pilotportalsite_id:
        'starluxairlines.sharepoint.com,408202e8-c4f0-4a2a-b294-5515d52c9fa1,0a36af78-8b15-4f22-b492-a392afe1be2f',
      eipsite_id:
        'starluxairlines.sharepoint.com,afcf72c6-d604-42b6-8da4-831bfaab02df,707530a2-f175-483e-96e9-aefe2fec6c69',
      testsite_id:
        'starluxairlines.sharepoint.com,b65bf87e-43e7-492a-98f7-18548c65de6b,a9c201db-1a93-40f9-b400-25afdfb0300d'
    },
    pilotportal: {
      news_list: 'NewsClip',
      notice_list: 'Notice',
      admin_list: 'Admin List',
      bulletin_id: 'b!6AKCQPDEKkqylFUV1SyfoXivNgoViyJPtJKjkq_hvi8l9zoVCDKWSLrEbR-Ln9CL',
      manual_id: 'b!6AKCQPDEKkqylFUV1SyfoXivNgoViyJPtJKjkq_hvi9oQJwarx1JSJuWKEpCGjdg',
      'personnel info_id': 'b!6AKCQPDEKkqylFUV1SyfoXivNgoViyJPtJKjkq_hvi_SNdgxHar4Rajl93_66lqi',
      'training material_id': 'b!6AKCQPDEKkqylFUV1SyfoXivNgoViyJPtJKjkq_hvi9IjZ7girHAQ4T40K4VfJoE',
      'Check Pilots (CP)_id': 'b!6AKCQPDEKkqylFUV1SyfoXivNgoViyJPtJKjkq_hvi_mRQ6wSv6PQar6n0eWFUbz',
      'Instructor Pilots (IP)_id': 'b!6AKCQPDEKkqylFUV1SyfoXivNgoViyJPtJKjkq_hvi8BRLJYS31VQJM-v2lIfYAl',
      'supervisory pilots_id': 'b!6AKCQPDEKkqylFUV1SyfoXivNgoViyJPtJKjkq_hvi9t_UCO8xPEQZ09_tKbKYsk',
      pss_id: 'b!6AKCQPDEKkqylFUV1SyfoXivNgoViyJPtJKjkq_hvi9Nr1iObtzgRpZa17x5yukO',
      hotel_id: 'b!6AKCQPDEKkqylFUV1SyfoXivNgoViyJPtJKjkq_hvi-r4dJBqqiiTaZTRuNPhHuY',
      'CASE STUDY_id': 'b!6AKCQPDEKkqylFUV1SyfoXivNgoViyJPtJKjkq_hvi_ZKbk4TC-nSaH_BBbiOx7n',
      airportInfo_id: 'b!6AKCQPDEKkqylFUV1SyfoXivNgoViyJPtJKjkq_hvi-14iFpSW55QZyiYZhKBmyh',
      crewconnect_list: 'Crew Connect',
      category: ['General', 'A321', 'A330', 'A350'],
      pilot: ['Check Pilots (CP)', 'Instructor Pilots (IP)']
    },
    post_logout_redirect_uri: 'https://pilotstarspace-uat.starlux-airlines.com/#/login'
  }
}

export default { config }
